module.exports = __webpack_public_path__ + "img/menu1.6c34b040.svg";